import {useSyncExternalStore} from 'react'
import {getToken, subscribeToken} from './client'

/**
 * Текущий токен для адресов картинок.
 *
 * Раньше адрес собирался через tokenForUrl() — обычную функцию, о смене
 * которой React ничего не знал. Токен обновлялся, а <img> оставались со
 * старым адресом до следующей перерисовки по другой причине: отсюда и
 * «аватарки пропали, помогает кнопка обновить».
 *
 * useSyncExternalStore перерисовывает всех, кто читает токен, ровно в
 * момент его смены.
 */
export const useApiToken = () => useSyncExternalStore(subscribeToken, getToken)
